<template>
  <div>
    <div class="friend-link">
      <div class="owidth">
        <p class="friend-link-label">友情链接:</p>
        <div class="friend-link-region">
          <select @change="chooseLink($event.target.value)">
            <option value="">
              ———— {{ friendLinks[0] && friendLinks[0].name }} ————
            </option>
            <option
              v-for="(item, index) in friendLinks[0].children"
              :key="index"
              :value="item.linkSite"
            >
              {{ item.name }}
            </option>
          </select>
          <select @change="chooseLink($event.target.value)">
            <option value="">
              ———— {{ friendLinks[1] && friendLinks[1].name }} ————
            </option>
            <option
              v-for="(item, index) in friendLinks[1].children"
              :key="index"
              :value="item.linkSite"
            >
              {{ item.name }}
            </option>
          </select>
          <select @change="chooseLink($event.target.value)">
            <option value="">
              ———— {{ friendLinks[2] && friendLinks[2].name }} ————
            </option>
            <option
              v-for="(item, index) in friendLinks[2].children"
              :key="index"
              :value="item.linkSite"
            >
              {{ item.name }}
            </option>
          </select>
        </div>
      </div>
    </div>
    <div class="bottom-nav">
      <div class="owidth">
        <router-link to="/notice/94">公告通知</router-link>
        <i>|</i>
        <router-link to="/service/100">文件下载</router-link>
        <i>|</i>
        <router-link to="/communicate/1530397132328181761"
          >投诉举报</router-link
        >
        <i>|</i>
        <router-link to="/service/1530393034107297793"
          >联系方式</router-link
        >
        <i>|</i>
        <router-link to="/about/127">中心地址</router-link>
      </div>
    </div>
    <div class="bottom-info">
      <a
        target="_blank"
        href="https://bszs.conac.cn/sitename?method=show&id=AA79557218E2B3C4E05310291AACA32E"
        ><img class="bottom-gov-icon" src="@/assets/icon-gov.png"
      /></a>
      <div class="bottom-info-content">
        <p>主办: {{ info.company }}</p>
        <p>网站访问量:{{info.countNumber}}</p>
        <p>技术服务电话：{{ info.phone }}</p>
        <p>{{ info.bottomAddress }}</p>
        <p>
          <a target="_blank" :href="info.recordUrl"
            >备案号: {{ info.recordNumber }}</a
          >
        </p>
        <!-- <p>
          <a target="_blank" :href="info.policeUrl"
            ><img src="@/assets/icon-copy.png" />豫公网安备
            {{ info.bottomPolice }}号</a
          >
        </p> -->
      </div>
    </div>
  </div>
</template>

<script>
import { getFriendsTreeData, getSiteInfo } from "@/api/api.js";
import { siteInfo, companyName } from "@/utils/auth.js";
export default {
  data() {
    return {
      friendLinks: [
        { name: "", children: [{ name: "" }] },
        { name: "", children: [{ name: "" }] },
        { name: "", children: [{ name: "" }] },
      ],
      info: {},
    };
  },
  methods: {
    loadSiteInfo() {
      getSiteInfo({ current: 1, size: 10 }).then((res) => {
        this.info = res.records[0];
        localStorage.setItem(siteInfo, JSON.stringify(this.info));
        localStorage.setItem(companyName, this.info.company);
      });
    },
    chooseLink(linkUrl) {
      if (linkUrl != "") window.open(linkUrl, "_blank");
    },
    getFriendLinks() {
      getFriendsTreeData().then((res) => {
        this.friendLinks = res;
      });
    },
  },
  created() {
    this.getFriendLinks();
    this.loadSiteInfo();
  },
  watch: {
    $route() {
      this.$nextTick(() => {
        let scrollTop = localStorage.getItem("scrollTop");
        if (scrollTop && scrollTop != "0") {
          window.scroll(0, parseInt(scrollTop));
        }
      });
    },
  },
};
</script>

<style scoped>
.friend-link {
  background-color: #f5f5f5;
  height: 64px;
  line-height: 64px;
  margin-top: 30px;
}
.friend-link-label {
  color: #0a50c1;
  font-size: 20px;
  float: left;
}
.friend-link-region {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-left: 20px;
}
.friend-link-region select {
  width: 32%;
  font-size: 14px;
  line-height: 30px;
  height: 30px;
  border: none;
  margin-top: 18px;
}
.bottom-nav {
  background-color: #3469c1;
  line-height: 64px;
  text-align: center;
  color: #fff;
  font-size: 14px;
  min-width: 1220px;
}
.bottom-nav a {
  color: #fff;
  margin: 0 20px;
  font-size: 14px;
}
.bottom-nav a:hover {
  text-decoration: underline;
}
.bottom-info {
  width: 560px;
  margin: 0 auto;
  padding: 40px 0 45px 0;
}
.bottom-gov-icon {
  float: left;
  width: 56px;
  height: 68px;
}
.bottom-info-content {
  margin-left: 90px;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  text-align: center;
  font-size: 14px;
  line-height: 30px;
}
/* .bottom-info-content p:last-child {
  width: 100%;
} */
.bottom-info-content a {
  font-size: 14px;
}
.bottom-info-content img {
  vertical-align: center;
  margin-right: 3px;
  margin-bottom: 2px;
}
/* .bottom-info {
} */
</style>
